import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class CreativeService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/creative/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();

  }

  previewZipCreativesFile(data: FormData, params = {}): Observable<any> {
    let url = `${this.BASE_API_URL}/creative/upload/`
    return this.post(this.buildUrl(url, "", params), data);
  }

  uploadNativeAssets(data: FormData, params = {}): Observable<any> {
    let url = `${this.BASE_API_URL}/creative/native-asset-upload/`
    return this.post(this.buildUrl(url, "", params), data);
  }

  getComponians(params = {}) {
    let url = `${this.BASE_API_URL}/creative/`
    return this.get(this.buildUrl(url, "", params));
  }

  submitForReAudit(id, data, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/creative/${id}/reaudit/`, '', params);
    return this.post(url, data);
  }

  malwareCheckOverride(id, data, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/creative/${id}/mc_override/`, '', params);
    return this.put(url, data);
  }

  updateLandingPage(id, landing_page_url, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/creative/${id}/landing_page/`, '', params);
    return this.put(url, { 'landing_page': landing_page_url });
  }

  getDetails(url) {
    return this.http.get(url, { responseType: "text" });
  }

  activateDeactivateCreative(id, action: 'activate' | 'deactivate', params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/creative/${id}/${action}/`, '', params);
    return this.put(url, {});
  }

  getCreativeSizes(params={}) {
    let url = this.buildUrl(`${this.resource_url}sizes`, '', params);
    return this.get(url);
  }

  getCreativeLimitDetails(params = {}) {
    let url = this.buildUrl(`${this.resource_url}asset-limits`, '', params);
    return this.get(url);
  }

  // deleteCreative(id, params = {}) {
  //   let url = this.buildUrl(`${this.BASE_API_URL}/creative/`, id, params);
  //   console.log('delete url', url)
  //   return this.delete(url)
  // }
}

@Injectable({
  providedIn: "root",
})
export class CreativeFolderService extends BaseEntityService {

  // changed with dashboard
  public resource_url = `${this.BASE_API_URL}/creative-folder/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  moveCreatives(folder_id, creative_ids, params = {}, action: 'add' | 'remove' = 'add') {
    let data = {
      "action": action,
      "creatives": creative_ids
    }
    return this.put(this.buildUrl(`${this.resource_url}${folder_id}/move/`, '', params), data);
  }
}
